module.exports = __webpack_public_path__ + "img/story-img3.6caa8dba.jpg";